export const DATE_PICKER_HEIGHT = 390;
export const CALENDAR_POSITION = {
  up: 'up',
  down: 'down',
};

export const DATE_PICKER_CLASS_NAMES = ['SingleDatePicker_picker', 'DateRangePicker_picker'];

export * from './datePickerModes';
